import { render, staticRenderFns } from "./coordinateList.vue?vue&type=template&id=1fe25bf5&scoped=true&"
import script from "./coordinateList.vue?vue&type=script&lang=js&"
export * from "./coordinateList.vue?vue&type=script&lang=js&"
import style0 from "./coordinateList.vue?vue&type=style&index=0&id=1fe25bf5&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe25bf5",
  null
  
)

export default component.exports